/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Detail_No_Slots_TitleInputs */

const en_job_detail_no_slots_title = /** @type {(inputs: Job_Detail_No_Slots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add interview time slots`)
};

const de_job_detail_no_slots_title = /** @type {(inputs: Job_Detail_No_Slots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine für Bewerbungsgespräche anlegen`)
};

/**
* | output |
* | --- |
* | "Add interview time slots" |
*
* @param {Job_Detail_No_Slots_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_detail_no_slots_title = /** @type {((inputs?: Job_Detail_No_Slots_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Detail_No_Slots_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_detail_no_slots_title(inputs)
	return en_job_detail_no_slots_title(inputs)
});